export default {
  companyTargetsMetadata: {
    exportFileName: 'Результаты_по_целям_курируемых_сотрудников',
    userName: 'ФИО сотрудника',
    status: 'Статус',
    type: 'Тип',
    period: 'Период',
    userHeaders: {
      name: 'ФИО сотрудника',
      employeeAvg: 'Ср. оценка сотрудника',
      curatorAvg: 'Ср. оценка <br/> руководителя/куратора',
      curatorAvgMobile: 'Ср. оценка руководителя/куратора',
      efficiency: 'Эффективность',
    },
    targetHeaders: {
      name: 'Наименование цели',
      importance: 'Важность',
      status: 'Статус',
      employeeScore: 'Оценка сотрудника',
      curatorScore: 'Оценка <br> руководителя/куратора',
      curatorScoreMobile: 'Оценка руководителя/куратора',
      type: 'Тип',
      progress: 'Прогресс',
      deadline: 'Дедлайн',
    },
    startReviewTargets: 'Начать оценку по целям',
    allowTargetCompletion: 'Разрешить перевод цели в статус «Завершена»',
    confirmMoveTargets: {
      title: 'Изменить статус целей?',
      button: 'Да, изменить',
      text: 'Статус выбранных целей будет изменён на: «{status}»',
    },
    confirmArchiveTargets: {
      title: 'Перемещение целей в архив',
      button: 'Да, перенести',
      text: 'Вы действительно хотите перенести цели в архив? Архивные цели не будут участвовать в расчёте эффективности и средних оценок.',
    },
    confirmUnarchiveTargets: {
      title: 'Перемещение целей из архива в текущие',
      button: 'Да, перенести',
      text: 'Вы действительно хотите перенести цели в список текущих?',
    },
    confirmStartReviewTargets: {
      title: 'Начать оценку по целям?',
      button: 'Да, продолжить',
      text: 'При выполнении данного действия все согласованные цели или находящиеся в работе будут переведены в статус оценки',
    },
    tooltips: {
      exportTargets: 'Выгрузить в excel все результаты по всем курируемым сотрудникам',
      efficiency: 'Процент завершенных целей от согласованных',
      scoreAvg:
        'Средняя рассчитана как среднее арифметическое взвешенное всех оценок по цели: сумма целей, умноженных на свои веса, делённая на сумму всех весов. Вес цели определяется автоматически в зависимости от установленной важности.',
      startReviewTargets:
        'При выполнении данного действия все согласованные цели или находящиеся в работе будут переведены в статус оценки',
      allowTargetCompletion:
        'При выключенном параметре цель не будет переведена в статус «Завершена», и исполнитель не увидит оценку куратора',
    },
    successMessages: {
      archiveTargets: 'Цели успешно перемещены в архив',
      unarchiveTargets: 'Цели успешно перемещены в текущие',
      moveTarget: 'Статус цели «{targetName}» успешно изменён',
      changeAllowTargetCompletion: 'Успешно изменено',
      startReviewTargets: 'Цели успешно переведены в статус оценки',
      changeSettings: 'Настройки успешно изменены',
    },
    errorMessages: {
      archiveTargets: 'Не удалось переместить цели в архив',
      unarchiveTargets: 'Не удалось переместить цели в текущие',
      moveTarget: 'Не удалось изменить статус цели «{targetName}»',
      exportTargets: 'Не удалось выгрузить результаты',
      changeAllowTargetCompletion: 'Не удалось изменить',
      startReviewTargets: 'Не удалось перевести цели в статус оценки',
      changeSettings: 'Не удалось изменить настройки',
    },
    noTargets: 'У вас ещё нет ни одной курируемой цели.',
    noArchivalTargets: 'У вас ещё нет ни одной архивной цели.',
    skipSelfEval: 'Не использовать самооценку сотрудника по целям',
    allowEditAfterApprove: 'Разрешить редактирование цели после согласования',
    assigneeCommentRequired: 'Комментарий сотрудника обязательный к заполнению',
    autoRunAssessment: 'Запускать оценку по целям автоматически',
    allowProgressAbove100: 'Разрешить исполнителю цели ставить % выполнения выше 100%',
    descriptions: {
      allowEditAfterApprove:
        'Редактирование цели будет доступно куратору цели и организатору компании на любом этапе достижения цели. При этом сотрудник так же может редактировать цель, когда она уже была согласована или находится у исполнителя в работе. При внесении изменений с обеих сторон исполнитель и куратор цели получат уведомления о том, что цель была изменена.',
      assigneeCommentRequired:
        'Установите этот чекбокс, чтобы сотрудник обязательно прокомментировал выполнение поставленной цели.',
    },
  },
};
